import './App.scss';
import React, { useState, useEffect } from 'react';
import { Navbar } from './components';
import { Loader, Header, About, Projects, Footer } from './container';

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 6000);
  }, []);
  return (
    <div className="App">
      {
        loading ?
          <Loader />
          :
          <section>
            <Navbar />
            <Header />
            <About />
            <Projects />
            <Footer />
          </section>
      }
    </div>
  );
}

export default App;
